(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["afiba-probeerweek-badge"] && !Shopify.designMode) return;
  try {
    function refreshSebiOfferBadges(){document.querySelectorAll('[data-sebi-offer-product]').forEach(badge=>{const scope=badge.closest('product-info')||document;const input=scope.querySelector('form[action*="/cart/add"] input[name="id"]');if(input)badge.hidden=!badge.dataset.offerVariants.split(',').includes(String(input.value));});}
document.addEventListener('change',()=>setTimeout(refreshSebiOfferBadges,80),true);
document.addEventListener('click',()=>setTimeout(refreshSebiOfferBadges,80),true);
document.addEventListener('DOMContentLoaded',refreshSebiOfferBadges);
const afibaBadgeObserver=new MutationObserver(refreshSebiOfferBadges);document.querySelectorAll('product-info').forEach(info=>afibaBadgeObserver.observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['value']}));
refreshSebiOfferBadges();
  } catch(e) { console.error(e); }
})();

})();
